import React, { useState, useEffect } from "react";
import Navbar from "../navbar/Navbar";
import axios from "axios";
import { useParams, Link } from "react-router-dom";

import Loader from "react-js-loader";
import Readjournal from "../journal/Readjournal";
import defaultProfilePicture from "./download2.jpg";

const Profile = () => {
  const [userDetails, setUserDetails] = useState(null);

  // Accessing username from URL params
  const { username } = useParams();

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(
          `https://happyu.onrender.com/${username}/getuserdetails`
        );
        setUserDetails(response.data);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    fetchUserDetails();
  }, [username]);

  if (!userDetails) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <Loader
          type="spinner-cub"
          bgColor={"#00B997"}
          color={"#FFFFFF"}
          size={100}
        />
      </div>
    );
  }

  return (
  <>
    <main className="profile-page bg-gradient-to-b from-teal-100 via-indigo-100 to-blue-100 min-h-screen pt-0">
      {/* Hero Banner */}
      <section className="relative block h-[340px]">
        <div
          className="absolute top-0 w-full h-full bg-center bg-cover"
          style={{
            backgroundImage: "url('/bg1.jpg')",
          }}
        >
          <span className="w-full h-full absolute opacity-40 bg-gradient-to-r from-[#fbcba2] to-[#001026]"></span>
        </div>
        <div
          className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-[70px]"
          style={{ transform: "translateZ(0px)" }}
        >
          {/* Decorative Curve */}
          {/* <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            viewBox="0 0 2560 100"
            fill="currentColor"
          >
            <polygon points="2560 0 2560 100 0 100"></polygon>
          </svg> */}
        </div>
      </section>

      {/* Profile Card */}
      <section className="relative -mt-40 z-10 pb-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto bg-white backdrop-blur shadow-2xl rounded-3xl overflow-hidden">
            <div className="flex flex-col md:flex-row items-center md:items-start px-8 pt-12 pb-8">
              {/* Profile Pic */}
              <div className="flex-shrink-0 relative -translate-y-12 md:translate-y-0 md:-mt-1 mb-4 md:mb-0 md:mr-8">
                <img
                  alt="Profile"
                  src={
                    userDetails.profilePicture
                      ? `https://happyu.onrender.com/${userDetails.profilePicture}`
                      : defaultProfilePicture
                  }
                  className="w-32 h-32 md:w-36 md:h-36 rounded-full border-4 border-teal-200 shadow-lg object-cover"
                />
              </div>

              {/* Details Columns */}
              <div className="flex-1 w-full">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-3xl font-bold text-indigo-900 capitalize">
                    {userDetails.name}
                  </h3>
                  <Link
                    to={`/${userDetails.username}/updateprofile`}
                    className="bg-teal-500 hover:bg-indigo-500 transition text-white font-semibold py-2 px-4 text-sm rounded-xl shadow"
                  >
                    Update Profile
                  </Link>
                </div>
                <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-1 sm:space-y-0 mb-2 text-gray-600 text-sm">
                  <div>
                    <span className="font-medium">Age:</span> {userDetails.age}
                  </div>
                  <div>
                    <span className="font-medium">Email:</span>{" "}
                    {userDetails.email}
                  </div>
                </div>
                <div className="flex space-x-8 mt-2 mb-6">
                  <div className="text-center">
                    <span className="text-xl font-bold block text-teal-700">
                      {userDetails.journals.length}
                    </span>
                    <span className="text-xs text-gray-500">Journals</span>
                  </div>
                </div>
                {userDetails.bio && (
                  <div className="mb-4 bg-gradient-to-l from-indigo-50 to-teal-50 rounded-xl shadow-inner p-6">
                    <p className="text-base text-gray-700">{userDetails.bio}</p>
                  </div>
                )}

                <div className="flex justify-center md:justify-end mt-4">
                  <Link to={`/${username}/createjournal`}>
                    <button
                      className="bg-indigo-500 hover:bg-teal-500 transition text-white font-bold py-2 px-5 rounded-xl shadow"
                      type="button"
                    >
                      Create Journal
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Journals */}
      <Readjournal />
    </main>
  </>
);

};

export default Profile;
